import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProductCategoryCostEntity } from './product-category-cost.model';

@Injectable({
    providedIn: 'root'
})
export class ProductCategoryCostService {
	private httpClient = inject(HttpClient);

	list(subscriberKey: number) {
			return this.httpClient.get<ProductCategoryCostEntity[]>(`api/subscriber/${subscriberKey}/product-category-costs`);
		}
}
